var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2482_16881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7112 25.3253V23.4378C30.7105 22.6013 30.4321 21.7888 29.9197 21.1277C29.4072 20.4667 28.6898 19.9945 27.8799 19.7854",
    stroke: "#FB7C51",
    strokeWidth: 1.88752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 25.3254V23.4379C25.0473 22.4367 24.6495 21.4765 23.9416 20.7685C23.2336 20.0606 22.2734 19.6628 21.2722 19.6628H13.7221C12.7209 19.6628 11.7607 20.0606 11.0528 20.7685C10.3448 21.4765 9.94708 22.4367 9.94708 23.4379V25.3254",
    stroke: "#FB7C51",
    strokeWidth: 1.88752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1035 8.46033C24.9155 8.66824 25.6353 9.1405 26.1492 9.80265C26.6632 10.4648 26.9422 11.2792 26.9422 12.1174C26.9422 12.9556 26.6632 13.77 26.1492 14.4322C25.6353 15.0943 24.9155 15.5666 24.1035 15.7745",
    stroke: "#FB7C51",
    strokeWidth: 1.88752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4985 15.8877C19.5834 15.8877 21.2736 14.1976 21.2736 12.1127C21.2736 10.0278 19.5834 8.33765 17.4985 8.33765C15.4136 8.33765 13.7235 10.0278 13.7235 12.1127C13.7235 14.1976 15.4136 15.8877 17.4985 15.8877Z",
    stroke: "#FB7C51",
    strokeWidth: 1.88752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2482_16881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6503,
    height: 22.6503,
    fill: "white",
    transform: "translate(9.004 5.50647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employeesIcon.b9a07a05602b08e644db9e3a3b855a8c.svg";
export { ForwardRef as ReactComponent };